import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Phone, CalendarDays } from "lucide-react";
import Reveal from "@/components/Reveal";
import SEO from "@/components/SEO";
import { useSite } from "@/context/SiteContext";
import { track } from "@/lib/api";

const MESSAGES = {
  quote: {
    title: "Your Quote Request Is on Its Way",
    body: "Thank you for reaching out. Michael will personally review your information and follow up with options suited to your needs, health, and budget. A confirmation email is on its way to you.",
  },
  contact: {
    title: "Your Message Has Been Received",
    body: "Thank you for getting in touch. Someone from 1907 Insurance Group will respond soon. A confirmation email is on its way to you.",
  },
  schedule: {
    title: "Your Call Request Is Scheduled for Review",
    body: "Thank you. Someone will be in contact soon to confirm a good time to talk. A confirmation email is on its way to you.",
  },
};

export default function ThankYou() {
  const site = useSite();
  const [params] = useSearchParams();
  const type = params.get("type") || "quote";
  const msg = MESSAGES[type] || MESSAGES.quote;

  return (
    <>
      <SEO title={`${msg.title} | 1907 Insurance Group`} description="Thank you for contacting 1907 Insurance Group." />
      <section className="py-20 md:py-32" data-testid="thank-you-page">
        <div className="container-site max-w-2xl text-center">
          <Reveal>
            <CheckCircle2 className="mx-auto h-16 w-16 text-gold-dark" aria-hidden="true" />
            <h1 className="mt-6 text-4xl sm:text-5xl tracking-tight" data-testid="thank-you-title">{msg.title}</h1>
            <p className="mt-6 text-lg text-mutedink leading-relaxed">{msg.body}</p>
            <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
              <a href={`tel:${site.phone_href}`} className="btn-primary" data-testid="thank-you-call-button"
                onClick={() => track("phone_click", { location: "thank_you" })}>
                <Phone className="h-5 w-5" aria-hidden="true" /> Call Now — {site.phone_display}
              </a>
              {type !== "schedule" && (
                <Link to="/schedule" className="btn-outline" data-testid="thank-you-schedule-button"
                  onClick={() => track("schedule_click", { location: "thank_you" })}>
                  <CalendarDays className="h-5 w-5" aria-hidden="true" /> Pick a Call Time
                </Link>
              )}
            </div>
            <p className="mt-8 text-sm text-mutedink">
              No pressure and no obligation — just straightforward help understanding your options.
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
